import { PeriodType } from '@mg-platform/core/core-data-access'
import { IAdminSimpleShop } from './shop.interface'
import { IPaginationFilteredResponse } from '@mg-platform/core/core-feature'
import { ShopFocusType } from '../enums/shop-focus-type.enum'
import { ShopTagSize } from '@mg-platform/reports/reports-data-access'
import { PosType } from '@mg-platform/admin-reports/admin-reports-data-access'

export interface IAdminShopsResponse extends IPaginationFilteredResponse {
  shops: IAdminSimpleShop[]
}

export interface IUpdateShopTagSizeRequest {
  period?: PeriodType
  from?: string | Date
  to?: string | Date
}

export interface IAdminShopServicePrices {
  laborRate: number
  alignment: number
  oilChange: number
}

export interface IAdminShopOperations {
  shopSales: ShopTagSize
  shopFocus: ShopFocusType
  servicePrices: IAdminShopServicePrices
  yearSales?: number
  yearSalesLabel?: string
}

export interface IAdminUnimportedShop {
  id: number
  nickname: string
  name: string
  address: string
  city: string
  state: string
  email: string
  phone: string
  postcode: string
  posType: PosType
  notifiedDate: Date
}

export interface IAdminUnimportedShopsResponse extends IPaginationFilteredResponse {
  shops: IAdminUnimportedShop[]
}
